import { SpUserService } from '../shared/services/sp-user.service';

export function userProviderFactory(userService: SpUserService) {
  return () => {
    return new Promise((resolve) => {
      userService.initUser().finally(() => resolve(null));
    });
  };
}
